const React = require("react");
const T = React.PropTypes;

const HistoricalFile = require("../types/HistoricalFile.js");

const FileIcon = require("./FileIcon.jsx");
const ProcessingMark = require("./ProcessingMark.jsx");
const CompletedMark = require("./CompletedMark.jsx");
const ErrorMark = require("./ErrorMark.jsx");

const styles = {
    Figure: {
        textAlign: "center"
    },
    IconWrapper: {
        position: "relative",
        display: "inline-block",
        width: 65
    },
    Icon: {
        display: "block",
        fontSize: 71,
        marginBottom: 10,
        textShadow: "0 3px 5px #bbb"
    },
    Mark: {
        position: "absolute",
        top: 45,
        left: -3
    }
};

const HistoryFileEmblem = React.createClass({
    propTypes: {
        HistoricalFile: HistoricalFile.Type.isRequired,
        IconStyle: T.object
    },
    getDefaultProps(){
        return {
            IconStyle: {}
        }
    },
    render() {
        const iconStyle = Object.assign({}, styles.Icon, this.props.IconStyle);

        return (<figure style={styles.Figure}>
            <div style={styles.IconWrapper}>
                <FileIcon style={iconStyle} />
                {this.props.HistoricalFile.Completed === null && (<ProcessingMark style={styles.Mark} />)}
                {this.props.HistoricalFile.Completed !== null && this.props.HistoricalFile.Errored && (<ErrorMark style={styles.Mark} />)}
                {this.props.HistoricalFile.Completed !== null && !this.props.HistoricalFile.Errored && (<CompletedMark style={styles.Mark} />)}
            </div>
            <div>{this.props.HistoricalFile.FileName}</div>
        </figure>);
    }
});

module.exports = HistoryFileEmblem;


// WEBPACK FOOTER //
// ./src/components/HistoryFileEmblem.jsx